import { ActionCell } from './ActionCell'
import { withActionCell } from './withActionCell'

const ConnectedActionCell = withActionCell(ActionCell)
export { ConnectedActionCell as ActionCell }
